import {
  roleAssignmentAdapter,
  MyOrganizationState,
  RoleAssignmentState
} from "@organizations/models";
import { selectMyOrganizationsState, roleAssignmentsReducer } from "@organizations/store/reducers";
import { createSelector } from "@ngrx/store";

const { selectAll } = roleAssignmentAdapter.getSelectors();

export const selectRoleAssignmentsState = createSelector(
  selectMyOrganizationsState,
  (state: MyOrganizationState) => state.roleAssignments as RoleAssignmentState
);

export const selectRoleAssignmentsLoading = createSelector(
  selectRoleAssignmentsState,
  roleAssignmentsReducer.getRoleAssignmentsLoading
);

export const selectAllRoleAssignments = createSelector(selectRoleAssignmentsState, selectAll);
